import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { EmptyFilter, OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { provinces } from '../state-codes';
import { sanitizeTextFilter } from 'utils/search.utils';

export const createdATFilter: Filter = {
  filter: 'common:createdAt',
  translate: true,
  type: FilterType.DATE,
  key: 'createdAt',
  field: 'createdAt',
};

export const createdDateFilter: Filter = {
  filter: 'common:date',
  translate: true,
  type: FilterType.DATE,
  key: 'createdAt',
  field: 'createdAt',
};

export const dateFilter: Filter = {
  filter: 'common:date',
  translate: true,
  type: FilterType.DATE,
  key: 'date',
  field: 'date',
};

const LOCATION_FIELD = 'locations';

export const getLocationFilterByField = (field: string = LOCATION_FIELD) => ({
  filter: 'common:fields.locations',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'zone',
  field,
  options: provinces?.map((pv) => ({
    value: String(pv?.code),
    label: pv?.name,
  })),
});

export const phoneFilter: Filter = {
  filter: 'common:phone',
  translate: true,
  type: FilterType.TEXT,
  key: 'ph',
  field: 'phone',
  transform: (value: any) => {
    const queryText = sanitizeTextFilter(value);
    if (!queryText) return undefined;
    return new TermFilter({
      field: 'phone',
      value: {
        $regex: queryText,
        $options: 'i',
      },
    });
  },
};

export const mainPhoneFilter: Filter = {
  filter: 'common:phone',
  translate: true,
  type: FilterType.TEXT,
  key: 'ph',
  field: 'contacts.mainPhone',
  transform: (value: any) => {
    const queryText = sanitizeTextFilter(value);
    if (!queryText) return undefined;
    return new TermFilter({
      field: 'contacts.mainPhone',
      value: {
        $regex: queryText,
        $options: 'i',
      },
    });
  },
};

export const STATUS: Record<string, string> = {
  ACTIVE: 'true',
  INACTIVE: 'false',
};

export const getVisibleFilter = (field?: string, header?: string, labels: Record<string, string> = {}) => ({
  filter: header || 'common:fields.visible.title',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'visible',
  field: field || 'visible',
  options: Object.keys(STATUS).map((key) => ({
    value: STATUS[key],
    translate: true,
    label: labels?.[key] || `common:fields.visible.${key.toLocaleLowerCase()}`,
  })),
  transform: (value: any) => {
    if (Array.isArray(value)) return new EmptyFilter();
    switch (value) {
      case 'false':
        return new OperatorFilter({
          type: 'OR',
          filters: [
            new TermFilter({ field: field || 'visible', value: false }),
            new TermFilter({ field: field || 'visible', value: null }),
          ],
        }).toQuery();
      case 'true':
        return new TermFilter({ field: field || 'visible', value: true }).toQuery();
    }
  },
});

export const getBoleanFilter = (field: string, header: string) => ({
  filter: header,
  translate: true,
  type: FilterType.FIXED_LIST,
  key: field,
  field,
  transform: (value: any) => {
    if (Array.isArray(value)) return undefined;
    if (value === 'false' || value === false) {
      return new OperatorFilter({
        type: 'OR',
        filters: [new TermFilter({ field, value }), new TermFilter({ field, value: null })],
      });
    }
    return new TermFilter({ field, value });
  },
  options: Object.keys(STATUS).map((key) => ({
    value: STATUS[key],
    translate: true,
    label: `causesIncidence:notification.${key.toLocaleLowerCase()}`,
  })),
});

export const fragileFilter = getBoleanFilter(
  'shippingSettings.shippingInfo.fragile',
  'order:shippingPackage.isFragile',
);

export const needRefrigerationFilter = getBoleanFilter(
  'shippingSettings.shippingInfo.needRefrigeration',
  'order:shippingPackage.needsRefrigeration',
);

export const emailFilter: Filter = {
  filter: 'clients:fields.email',
  translate: true,
  field: 'email',
  key: 'email',
  type: FilterType.TEXT,
  transform: (value: any) => {
    const queryText = sanitizeTextFilter(value);
    if (!queryText) return undefined;
    return new TermFilter({
      field: 'email',
      value: {
        $regex: queryText,
        $options: 'i',
      },
    });
  },
};
